import { useMutation, useQueryClient } from "react-query";
import { t } from "@/i18n-js/instance";
import { eventApi } from "@circle-react/api";
import type { Event } from "@circle-react/types/Event";
import { useToast } from "@circle-react-uikit/ToastV2";

interface RemoveCohostMutationProps {
  event: Event;
  onSuccess?: () => void;
}

export const useRemoveCohostMutation = ({
  event,
  onSuccess,
}: RemoveCohostMutationProps) => {
  const { success, error } = useToast();
  const queryClient = useQueryClient();
  const removeCohostMutation = useMutation(
    (attendeeId: string) =>
      eventApi.removeAttendeeById({
        event,
        attendeeId,
      }),
    {
      onSuccess: () => {
        success(t("events.event_attendee_deleted"));
        void queryClient.invalidateQueries("events-people-cohost");
        void queryClient.invalidateQueries("events-people-participant");
        onSuccess && onSuccess();
      },
      onError: () => error(t("events.can_not_delete_event_attendee")),
    },
  );

  return {
    removeCohostMutation,
  };
};
